import {
    Action,
    CombinedState,
    combineReducers,
    Reducer,
    ReducersMapObject
} from "redux";

const $HUBO_INIT = "hubo_init";

const initialReducerMap = <S, TAction extends Action>(): ReducersMapObject<
    S,
    TAction
> => {
    // @ts-expect-error
    return { [$HUBO_INIT]: () => ({}) };
};

const createReducerManager = <S, TAction extends Action>(
    initialReducers: ReducersMapObject<S, TAction> = initialReducerMap<
        S,
        TAction
    >()
) => {
    const reducers = { ...initialReducers };
    let combinedReducer = combineReducers(reducers);
    let keysToRemove: Array<keyof S> = [];

    return {
        getReducerMap() {
            return reducers;
        },
        reduce(state: CombinedState<S> | undefined, action: TAction) {
            if (keysToRemove.length > 0 && state) {
                state = { ...state };
                for (const key of keysToRemove) {
                    delete state[key];
                }
                keysToRemove = [];
            }

            if (!state) {
                return {};
            }

            return combinedReducer(state, action);
        },
        add(key: keyof S, reducer: Reducer<S[keyof S], TAction>) {
            if (!key) {
                return;
            }

            reducers[key] = reducer;

            combinedReducer = combineReducers(reducers);
        },
        remove(key: keyof S) {
            if (!key || !reducers[key]) {
                return;
            }
            delete reducers[key];
            keysToRemove.push(key);
            combinedReducer = combineReducers(reducers);
        }
    };
};

export default createReducerManager;
